export default __webpack_public_path__ + "static/media/Farhan Mohammed - Vice President.48ffa4da.jpg";